import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import App from './App';
import AuthProvider from './AuthProvider';  // <- import du provider
import './styles/globals.css';

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);
  
  root.render(
    <StrictMode>
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>           {/* <-- wrappe ton app avec AuthProvider */}
            <App />
          </AuthProvider>
          <Toaster 
            position="bottom-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#fff',
                color: '#363636',
                padding: '16px',
                borderRadius: '12px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                border: '1px solid rgba(0, 0, 0, 0.05)',
              },
              success: {
                iconTheme: {
                  primary: '#d03484',
                  secondary: '#fff',
                },
                style: {
                  border: '1px solid #d0348420',
                },
              },
              error: {
                iconTheme: {
                  primary: '#ef4444',
                  secondary: '#fff',
                },
                style: {
                  border: '1px solid #ef444420',
                },
              },
            }}
          />
        </BrowserRouter>
      </HelmetProvider>
    </StrictMode>
  );
}

